/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Daily_Limit_TitleInputs */



/**
* | output |
* | --- |
* | "Daily message limit reached" |
*
* @param {Chat_Daily_Limit_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_daily_limit_title = /** @type {((inputs?: Chat_Daily_Limit_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Daily_Limit_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tägliches Nachrichtenlimit erreicht")
	return /** @type {LocalizedString} */ ("Daily message limit reached")
});